import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service';
import { SnapshotService } from '../../../Services/snapshot.service';

@Injectable({
  providedIn: 'root'
})
export class PiechartService {

  constructor(private http: HttpClient, private commonchartmodules: CommonChartmoduleService, private _configService: SnapshotService) { }
  // color: string[] = [
  //   '#9BC5E5', '#D5BCE4', '#F9C099', '#FF97A8', '#A6E2D7',
  //   '#BDE6BD', '#BFE1FD', '#F4E4B3', '#CD978B', '#EAC4D5',
  //   '#FFCC99', '#6699CC', '#FF9999', '#66CCCC', '#FF9966',
  //   '#99CC66', '#FF99CC', '#CCCC99', '#FF9966', '#FFCC66',
  //   '#99CC99', '#FFCC00', '#99CCFF', '#FF6666', '#CCCC66'
  // ];
  // color: string[] = [
  //   "#0255cc", "#00b6ff", "#00e5ba", "#9ee900",
  //   "#00b600", "#2f6d2f", "#802ab7", "#c700d3",
  //   "#eb0064", "#eb0064", "#fedb00", "#847b4f",
  //   "#83c4b6", "#4d839e", "#aa91c4", "#f8ac8f",
  //   "#f2cf61", "#647032", "#4e4376", "#5a6670",
  //   "#003a5d", "#2d7f6f", "#453635", "#b75553",
  //   "#b8aaa2", "#ebdec5", "#c4c5c9", "#ddc2b7",
  //   "#d6ae7b", "#492a07"
  // ];
  // color: string[] = [
  //   "#9bc5e5",
  //   "#d5bce4",
  //   "#ff97a8",
  //   "#a7e2d7",
  //   "#ffcc66",
  //   "#ff9966",
  //   "#6799cc",
  //   "#cdcc66",
  //   "#f4e4b3",
  //   "#47b7ae",
  //   "#f9c099",
  //   "#7fb6c6",
  //   "#2c70a3",
  //   "#d6a365",
  //   "#802ab7",
  //   "#00b6ff",
  //   "#417f54",
  //   "#bf5c9e",
  //   "#62849b",
  //   "#e5ce85",
  //   "#ae3875",
  //   "#6750a4",
  //   "#798987",
  //   "#b2f9ee",
  //   "#dd8340",
  //   "#2d97a5",
  //   "#bd78ef",
  //   "#af7f4f",
  //   "#7f5aa3",
  //   "#5c752d"
  // ];
  color: string[]=this.commonchartmodules.color1;
  chartimagepath: string = 'assets/ImagesSnapshot/chartimages/group.png';
  linearGradients: any = this.color.map((color, index) => ({
    linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
    stops: [
      [0, "#FFFFFF"],
      [1, color.replace(/[^,]+(?=\))/, '0.1')] // Change the alpha to 0.1 for the second color stop
    ]
  }));
  allowAnimation: any = false;
  fontFamily: any = 'KantarBrown-Regular';

  linearGradients1 = this.color.map((color, index) => {
    const darkerShade = this.getDarkerShade(color);
    return {
      darkerShade: darkerShade,
      linearGradient: { x1: 0.4, x2: 0.5, y1: 0, y2: 0 },
      stops: [
        [0, color],
        [1, darkerShade]
      ]
    };
  });

  getDarkerShade(color: any) {
    const darkenFactor = 0.9; // Adjust this factor for a darker shade
    const rgb = color.substring(1); // Remove the '#' from the color
    const r = parseInt(rgb.substring(0, 2), 16);
    const g = parseInt(rgb.substring(2, 4), 16);
    const b = parseInt(rgb.substring(4, 6), 16);
    const darkerR = Math.round(r * darkenFactor);
    const darkerG = Math.round(g * darkenFactor);
    const darkerB = Math.round(b * darkenFactor);
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
  }
  samplesizeconstant: number = 9000;
  //data from json
  chartdata(): Observable<any> {
    return this.http.get<any>('assets/Data/piechart.json');
  }

  sunburstchartdata(): Observable<any> {
    return this.http.get<any>('assets/Data/sunburstchart.json');
  }


  list: any;
  PieChart1to10customizationList(): Observable<any[]> {
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => (item.Chart.trim() == "01/Pie Chart" || item.Chart.trim() == "02/Pie Chart" || item.Chart.trim() == "03/Pie Chart" || item.Chart.trim() == "04/Pie Chart" || item.Chart.trim() == "05/Pie Chart" || item.Chart.trim() == "06/Pie Chart" || item.Chart.trim() == "07/Pie Chart" || item.Chart.trim() == "08/Pie Chart" || item.Chart.trim() == "09/Pie Chart" || item.Chart.trim() == "10/Pie Chart"))
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0, this.commonchartmodules.commoncustomizationlist().length - 1)]
        return custom;
      })
    );
  }


  applycustomization(event: any, item: any, properties: any) {
    this.commonchartmodules.applycustomization(event, item, properties)
  }

  customization() {
    let custom: any = [
      {
        customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '', options: this._configService.clientSnapshotAllStudyNames
      },
      {
        customization: 'Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: '', id: '', select: 1, options: [
          { value: 'metric1', label: 'Metric 1' }, { value: 'metric2', label: 'Metric 2' }, { value: 'metric3', label: 'Metric 3' }, { value: 'metric4', label: 'Metric 4' },
        ]
      },
      {
        customization: 'Widget Name : ', func: 'applycustomization', inputType: 'text', className: '', id: ''
      },
    ];
    custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0, this.commonchartmodules.commoncustomizationlist().length - 1)];

    return custom;
  }


}
